import history from "../history"

export default function logout(){ 
    sessionStorage.clear()
    history.push("/")
}